import React from 'react';
import { FaPlus, FaFileExcel } from 'react-icons/fa';
import CustomDatePicker from '../../../../../../../../components/common/CustomDatePicker/CustomDatePicker';
import CheckboxMultiSelect from '../../../../../../../../components/common/CheckboxMultiSelect/CheckboxMultiSelect';
import {toast} from 'react-toastify';

interface FilterOption {
  value: string | number;
  label: string;
}

interface FilterBarProps {
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  estadoFiltro: FilterOption[];
  onEstadoFiltroChange: (estados: FilterOption[]) => void;
  onCreateArqueo: () => void;
  isPending?: boolean;
  pendingDetails?: { pedidos: number; receipts: number; cajas: number; cash: number };
  onExportToExcel?: () => void;
  exportDisabled?: boolean;
  totalArqueos?: number;
}

const FilterBar: React.FC<FilterBarProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  estadoFiltro,
  onEstadoFiltroChange,
  onCreateArqueo,
  isPending = false,
  pendingDetails,
  onExportToExcel,
  exportDisabled = false,
  totalArqueos = 0,
}) => {
  const estadoOptions: FilterOption[] = [
    { value: 'Cuadradas', label: 'Cuadradas' },
    { value: 'No Cuadradas', label: 'No Cuadradas' },
    { value: 'Cancelado', label: 'Cancelado' }
  ];

  const validateAndCreateArqueo = () => {
    if (isPending) {
      const parts: string[] = [];
      if (pendingDetails?.pedidos) parts.push(`${pendingDetails.pedidos} pedidos`);
      if (pendingDetails?.receipts) parts.push(`${pendingDetails.receipts} recibos`);
      if (pendingDetails?.cash) parts.push(`${pendingDetails.cash} movimientos de caja`);
      const detail = parts.length ? `: ${parts.join(', ')}` : '';
    
      toast.error(`Hay pendientes${detail}. Deben ser atendidos antes de crear un nuevo arqueo.`);
      return;
    }
    onCreateArqueo();
  };

  return (
    <div className="mp-toolbar">
      <div className="flex flex-wrap items-center gap-3">
        {/* Date pickers */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <CustomDatePicker
            value={startDate}
            onChange={onStartDateChange}
            placeholder="Desde"
          />
          <CustomDatePicker
            value={endDate}
            onChange={onEndDateChange}
            placeholder="Hasta"
          />
        </div>

        {/* Status filter */}
        <div className="min-w-[110px]">
          <CheckboxMultiSelect
            options={estadoOptions}
            value={estadoFiltro}
            onChange={onEstadoFiltroChange}
            placeholder="Estado"
          />
        </div>

        {/* Export */}
        {onExportToExcel && (
          <button
            className="mp-btn-export"
            onClick={onExportToExcel}
            disabled={exportDisabled || totalArqueos === 0}
          >
            <FaFileExcel />
            <span className="hidden sm:inline">Excel</span>
          </button>
        )}

        {/* Create button */}
        <button className="mp-btn-primary ml-auto" onClick={validateAndCreateArqueo}>
          <FaPlus /> <span>Nuevo Arqueo</span>
        </button>
      </div>
    </div>
  );
};

export default FilterBar;
